import { FilterType, filtersConfig } from "../pages/AgreementsDashboard/agreementsDashboardFilters";
export const buildRelationshipsParamsFilter = _ref => {
  let {
    type,
    isVendor,
    search,
    filters,
    clientContactId
  } = _ref;
  const filterParams = {};
  if (filters) {
    Object.entries(filtersConfig).forEach(_ref2 => {
      let [key, config] = _ref2;
      const value = filters[key];
      if (!value) return;
      if (key === FilterType.AgreementStatus && value.length > 0) {
        filterParams['agreementStatusV2'] = value.join(',');
      } else {
        Object.assign(filterParams, config.getRequestParam(value));
      }
    });
  }
  const relationshipSummariesTypeFilterMap = {
    agreement: 'approved,terminated',
    proposal: 'awaitingApproval,expired'
  };
  filterParams['status'] = relationshipSummariesTypeFilterMap[type];
  filterParams['search'] = search || undefined;
  filterParams['party'] = isVendor ? 'vendor' : 'customer';
  filterParams['clientContactId'] = clientContactId || undefined;
  return filterParams;
};